import { web } from "@/config/System";

export default function LoaderEGanesha() {
  return (
    <div className="fixed inset-0">
      <div
      // animate={{
      //   scale: [1, 2, 2, 1, 1],
      //   rotate: [0, 0, 270, 270, 0],
      //   borderRadius: ["20%", "50%", "20%", "20%", "50%"],
      // }}
      // transition={{ duration: 1.5 }}
      >
        <img
          src={web.logoApp}
          alt="e-Ganesha"
          width={100}
          className="animate-pulse absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
  );
}
